export enum ValidationWarningMessage {
  Required = 'Pakollisia tietoja puuttuu',
  RequiredInternationalPhone = 'Syötä tieto oikeassa muodossa (esim. +35850123123)',
  Invalid = 'Syötä tieto oikeassa muodossa',
  InvalidInternationalPhone = 'Syötä tieto oikeassa muodossa (esim. +35850123456)',
  HTJInvalid = 'Sallitut merkit kaikki utf-8 paitsi Unicode-merkit 0-31 ja 127.',
  NotPersonalId = 'Tunnus ei saa olla henkilötunnus',
  BusinessIdInvalid = 'y-tunnus on kelvoton tai y-tunnus on muodollisesti oikeanlainen, seitsemän numeroa, väliviiva ja tarkistusmerkki, mutta ei ole validi eli tarkistusmerkki ei täsmää',
}

export enum RenovationTypeCode {
  Painting = 752560000,
  Wallpapering = 752560001,
  BaseboardOrDoorListRenovation = 752560002,
  SiliconeRenewal = 752560003,
  ShowerScreenInstallation = 752560004,
  ReplacementOfAnIndividualFaucetByAPipeDealer = 752560005,
  InstallationOfAdditionalSocketsByAnElectrician = 752560006,
  ReplacingTheFloorMaterial = 752560007,
  RemovalOfFirmFurnitureFromADryPlaces = 752560008,
  BathroomSeamRepairsOrSiliconeReplacementOrRenewal = 752560009,
  ShowerCabinetInstallation = 752560010,
  KitchenRenovation = 752560011,
  BathroomRenovation = 752560012,
  ConstructionOfASauna = 752560013,
  OtherAlterationWorkSubjectToABuildingPermit = 752560014,
  RemovingAWall = 752560015,
  ElectricalWork = 752560016,
  HeatWaterOrAirConditioningWork = 752560017,
  BalconyOrTerraceGlazing = 752560018,
  YardRoofTerraceOrFence = 752560019,
  Other = 752560020,
  AirHeatPumpInstallation = 752560021,
  ElectricAndHybridCarCharging = 752560022,
  SaunaRenovation = 752560023,
  BuildingOrGlazingTerrace = 752560024,
  BalconyGlazing = 752560025,
  YardCanopyOrFence = 752560026,
  WallPaintingOrWallpapering = 752560027,
}

export const CODES_LEVEL = {
  low: [
    RenovationTypeCode.Painting,
    RenovationTypeCode.Wallpapering,
    RenovationTypeCode.BaseboardOrDoorListRenovation,
    RenovationTypeCode.SiliconeRenewal,
    RenovationTypeCode.ShowerScreenInstallation,
    RenovationTypeCode.ReplacementOfAnIndividualFaucetByAPipeDealer,
    RenovationTypeCode.InstallationOfAdditionalSocketsByAnElectrician,
    RenovationTypeCode.WallPaintingOrWallpapering,
  ],
  normal: [
    RenovationTypeCode.ReplacingTheFloorMaterial,
    RenovationTypeCode.RemovalOfFirmFurnitureFromADryPlaces,
    RenovationTypeCode.BathroomSeamRepairsOrSiliconeReplacementOrRenewal,
    RenovationTypeCode.ShowerCabinetInstallation,
  ],
  high: [
    RenovationTypeCode.SaunaRenovation,
    RenovationTypeCode.BuildingOrGlazingTerrace,
    RenovationTypeCode.BalconyGlazing,
    RenovationTypeCode.YardCanopyOrFence,
    RenovationTypeCode.KitchenRenovation,
    RenovationTypeCode.BathroomRenovation,
    RenovationTypeCode.ConstructionOfASauna,
    RenovationTypeCode.OtherAlterationWorkSubjectToABuildingPermit,
    RenovationTypeCode.RemovingAWall,
    RenovationTypeCode.ElectricalWork,
    RenovationTypeCode.HeatWaterOrAirConditioningWork,
    RenovationTypeCode.BalconyOrTerraceGlazing,
    RenovationTypeCode.YardRoofTerraceOrFence,
    RenovationTypeCode.AirHeatPumpInstallation,
    RenovationTypeCode.ElectricAndHybridCarCharging,
  ],
  other: [RenovationTypeCode.Other],
};

export enum RenovationTypesCodesLabels {
  Low = 'Vähäiset muutostyöt',
  Normal = 'Tavanomaiset muutostyöt',
  High = 'Merkittävät muutostyöt',
  Other = 'Muu muutostyö',
}

export const NOT_PERSONAL_ID_PATTERN =
  /^(?!(?:0[1-9]|[12]\d|3[01])(?:0[1-9]|1[0-2])\d{2}[-+A]\d{3}[0-9A-Z]$).+$/;
export const HTJ_STRING_PATTERN = /^[^\x00-\x1F\x7F]+$/;
export const HTJ_STRING_WITH_LINE_BREAKS_PATTERN =
  /^[^\x00-\x09\x0B-\x0C\x0E-\x1F\x7F]+$/;
export const BUSINESS_ID_PATTERN = /^[\d]{7}-[\d]$/;
export const EMAIL_PATTERN = new RegExp(
  // eslint-disable-next-line no-control-regex
  "^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$",
  'i'
);
export const PHONE_PATTERN = /^\+[1-9]{1}[0-9]{6,14}$/;
